module.exports = __webpack_public_path__ + "static/scale-model-of-stony-run-walking-path-in-baltimore-maryland-f1e2a2b9bfe4f1d892072c48032b7b64.png";